<template>
    <div class="leveled">   <!-- root header for klass detail  -->
      <div class="mark">Page2.vue</div>

      <transition name="slide" mode="out-in">
        <router-view></router-view>
      </transition>

        
    </div>
</template>





<script>

   export default {
        name: 'Page2',

    

    data: function () {
        return {
          getHeightOfApp: { },
            

            
        }
    },


    mounted () {
      this.matchHeight();
    },


    

    
    methods: {
      matchHeight () {
          
          var heightString = $('#componentBox').height();
          $('.nav-side').height(heightString);  
        },

    }//end methods





}


</script>










<style lang="scss">
.leveled{
    z-index: 10;
    position: relative;
}
.appheader,.head-name{
    z-index: 100;
    position: relative;
}
    .slide-leave-active {
        transition: opacity .5s ease;
        opacity: 0;
        animation: slide-out .5s ease-out forwards;
    }

    .slide-leave {
        opacity: 1;
        transform: translateX(0);
    }

    .slide-enter-active {
        animation: slide-in .7s ease-out forwards;
    }

    @keyframes slide-out {
        0% {
            transform: translateY(0);
        }
        100% {
            transform: translateY(500px);
        }
    }

    @keyframes slide-in {
         0% {
            transform: translateY(-250px);
        }
        100% {
            transform: translateY(0);
        }
    }



</style>
